import { Component } from '@angular/core';

@Component({
    templateUrl: './not-found-help.component.html',
    standalone: false
})
export class NotFoundHelpComponent { }
